// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ThemeTypography } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    titleStyle = "titleStyle",
    copy = "copy",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.titleStyle]: string;
        [fields.copy]: string;
    };
}

type Props = OwnProps;
export interface ContactSupportStyles {
    container?: InjectableCss,
}

export const contactSupportStyles: ContactSupportStyles = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 20px;
            box-shadow: inset 4px 0 0 0 ${color("common.ui6")};
            background-color: ${color("common.white")};
            width: 418px;
            ${xScreen("lte", "sm")} {
                width: 352px;
            }
            ${xScreen("lte", "xs")} {
                width: 328px;
            }
        `
    },
};

const styles = contactSupportStyles;

const ContactSupport = ({ id, fields: {
    title,
    titleStyle,
    copy,
} }: Props) => (
    <StyledWrapper className="contact-support" {...styles.container}>
        <Typography variant={titleStyle as keyof ThemeTypography}>
            {parse(title, parserOptions)}
        </Typography>
        <Typography>{parse(copy, parserOptions)}</Typography>
    </StyledWrapper>
)

const widgetModule: WidgetModule = {
    component: ContactSupport,
    definition: {
        group: "XNGAGE" as any,
        isSystem: true,
        fieldDefinitions: [
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable"
            },
            {
                name: fields.titleStyle,
                displayName: "Title Style",
                editorTemplate: "DropDownField",
                defaultValue: "h4",
                fieldType: "General",
                options: [
                    { displayName: "Heading 2", value: "h2" },
                    { displayName: "Heading 3", value: "h3" },
                    { displayName: "Heading 4", value: "h4" },
                    { displayName: "Heading 5", value: "h5" },
                    { displayName: "Heading 6", value: "h6" },
                ],
            },
            {
                name: fields.copy,
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "General"
            },
        ],
    },
};

export default widgetModule;
